import { AutoLoanCriteria, LoanCriteria, LoanStatus } from '@nemuru-eng/js-api-client';

import { DetailedLoanStatusTag } from '@/components/shared/components/DetailedLoanStatusTag';
import { Text } from '@/components/shared/components/Text';
import { ApplicationType } from '@/config/types';

interface ReportingStatusFieldColumnProps {
  flex?: number;
  sortable?: boolean;
}

export const reportingStatusFieldColumn = ({ flex, sortable = true }: ReportingStatusFieldColumnProps) => {
  return {
    flex: flex ?? 0.19,
    field: 'reporting_status',
    headerName: <Text tId={'STATUS'} />,
    sortable,
    renderCell: (rowData: { row: AutoLoanCriteria }) => (
      <div
        style={{
          minWidth: '120px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          whiteSpace: 'break-spaces',
          width: '100%',
        }}
      >
        <DetailedLoanStatusTag
          loan={rowData.row as unknown as LoanCriteria}
          status={rowData.row.reportingStatus as LoanStatus}
          applicationType={ApplicationType.AUTO}
          loanCriteria={rowData.row as unknown as LoanCriteria}
        />
      </div>
    ),
  };
};
